import Airdrop from "@/pages/Airdrop";
import Bonus from "@/pages/Bonus";
import Detailed from "@/pages/Detailed";
import History from "@/pages/History";
import Home from "@/pages/Home";
import MatchingBonus from "@/pages/MatchingBonus";
import MyDeposits from "@/pages/MyDeposits";
import Network from "@/pages/Network";
import NotFound from "@/pages/NotFound";
import Settings from "@/pages/Settings";
// import Support from "@/pages/Support";
// import Withdraw from "@/pages/Withdraw";
// import { useEffect, useState } from "react";
import { Navigate, Routes, Route } from "react-router";

const AppRoutes = () => {
  //   const location = useLocation();
  //   const [supportKey, setSupportKey] = useState(0);

  //   useEffect(() => {
  //     const prevPath = sessionStorage.getItem("prevPath") || "";
  //     const currentPath = location.pathname;

  //     if (currentPath === "/support" && prevPath !== "/support") {
  //       setSupportKey(Date.now());
  //     }

  //     sessionStorage.setItem("prevPath", currentPath);
  //   }, [location.pathname]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/deposit" element={<Navigate to="/" replace />} />
        {/* TODO: Disabled due to maintenance */}
        <Route path="/withdraw" element={<Navigate to="/" replace />} />
        {/* <Route path="/withdraw" element={<Withdraw />} /> */}
        <Route path="/network" element={<Network />} />
        <Route path="/airdrop" element={<Airdrop />} />
        <Route path="/my-deposits" element={<MyDeposits />} />
        <Route path="/network/detailed" element={<Detailed />} />
        <Route path="/bonus" element={<Bonus />} />
        <Route path="/history" element={<History />} />
        <Route path="/matching-bonus" element={<MatchingBonus />} />
        <Route path="*" element={<NotFound />} />
        {/* <Route path="/support" element={<Support key={supportKey} />} /> */}
      </Routes>
    </>
  );
};

export default AppRoutes;
